module.exports = __webpack_public_path__ + "img/img6.144fcc95.png";